import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Notification, { Position } from '../../../components/Notification';
import { ValidationResult } from 'shared/utils/validators';

export interface Props {
  name: string;
  classNameError?: string;
  classNameHint?: string;
  hint?: React.ReactNode;
  error?: ValidationResult;
  position: Position;
}

export const Tooltip: React.FC<Props> = ({
  name,
  error,
  position,
  hint,
  classNameHint,
  classNameError,
}) => {
  const { t } = useTranslation();
  if (error) {
    return (
      <Notification
        className={classNameError}
        level="error"
        position={position}
        data-testid={`${name}-error-notification`}
      >
        {t(error.message, error.details)}
      </Notification>
    );
  }

  if (hint) {
    return (
      <Notification className={classNameHint} position={position} data-testid={`${name}-hint`}>
        {hint}
      </Notification>
    );
  }

  return null;
};
